<template>
	<div class="container mt-4">
		<div class="row">
			<div class="col-lg-8">
				<div class="dashboard-section leaves-section">
					<div class="section-header">
						<h2><i class="fas fa-calendar-alt"></i> Congés</h2>
					</div>
					<div class="cards-grid">
						<router-link :to="{ name: 'leavesnew' }" class="dashboard-card new-leave-card">
							<div class="card-icon">
								<i class="fas fa-plus-circle"></i>
							</div>
							<div class="card-content">
								<h3>Nouvelle demande</h3>
								<p>Créer une demande de congé</p>
							</div>
						</router-link>

						<router-link :to="{ name: 'leaves' }" class="dashboard-card my-leaves-card">
							<div class="card-icon">
								<i class="fas fa-history"></i>
							</div>
							<div class="card-content">
								<h3>Mes congés</h3>
								<p>Voir mes demandes</p>
							</div>
						</router-link>

						<router-link
							v-if="isValidator"
							:to="{ name: 'leavesvalidation' }"
							class="dashboard-card validation-card"
						>
							<div class="card-icon">
								<i class="fas fa-check-circle"></i>
								<span v-if="nbtovalidate > 0" class="notification-badge">{{ nbtovalidate }}</span>
							</div>
							<div class="card-content">
								<h3>Validation</h3>
								<p>Gérer les demandes</p>
							</div>
						</router-link>
					</div>
				</div>
				<div v-if="user.has_ndf" class="dashboard-section expenses-section">
					<div class="section-header">
						<h2><i class="fas fa-receipt"></i> Notes de frais</h2>
					</div>
					<div class="cards-grid">
						<router-link :to="{ name: 'scan' }" class="dashboard-card scan-card">
							<div class="card-icon">
								<i class="fas fa-camera"></i>
							</div>
							<div class="card-content">
								<h3>Ajouter une note de frais</h3>
								<p>Numériser ou importer une note de frais</p>
							</div>
						</router-link>

						<router-link :to="{ name: 'expenses' }" class="dashboard-card expenses-card">
							<div class="card-icon">
								<i class="fas fa-list-ul"></i>
							</div>
							<div class="card-content">
								<h3>Mes notes</h3>
								<p>Consulter l'historique</p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="dashboard-section">
					<div class="section-header mt-3 mb-0 pb-0 d-flex justify-content-between align-items-center">
						<h5><i class="fas fa-clock"></i> Congés en validation</h5>
					</div>
					<Leaves :leaves="pendingLeaves" :show-status="false"></Leaves>
					<div class="mt-2 text-secondary" v-if="!pendingLeaves.length">
						Aucun congé en validation
					</div>
					<div class="section-header mt-4 mb-0 pb-0 d-flex justify-content-between align-items-center">
						<h5><i class="fas fa-calendar-week"></i> Prochains congés</h5>
					</div>
					<div class="mt-2 text-secondary" v-if="!nextLeaves.length">
						Aucun congé prévu
					</div>
					<Leaves :leaves="nextLeaves" :show-status="false"></Leaves>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {formatDate} from "../../plugins/helpers.js";
import {NButton, NIcon, NList, NListItem, NPopconfirm, NSpace, NTag, NThing} from "naive-ui";
import moment from 'moment';
import Leaves from "../Leaves.vue";

export default {
	components: {Leaves, NSpace, NThing, NTag, NButton, NPopconfirm, NList, NIcon, NListItem},
	methods: {
		...mapActions(['fetchLeaves']),
		formatDate,
	},
	data() {
		return {
			nbtovalidate: 0,
			showedLeavesDetails: [],
		}
	},
	mounted() {
		this.fetchLeaves();

		const pb = this.getPb;
		if (this.isValidator) {
			pb.collection('leaves').getFullList({
				filter: "status = 'pending'",
			}).then((leaves) => {
				this.nbtovalidate = leaves.length;
			});
		}
	},
	computed: {
		...mapGetters(['getPb', 'getLeaves', 'getUser']),
		isValidator() {
			return this.getUser.utilisateurid === '10';
		},
		pendingLeaves() {
			return this.getLeaves.filter(leave => leave.status === 'pending')
		},
		nextLeaves() {
			return this.getLeaves.filter(leave => {
				return leave.validate_at && moment(leave.start).isAfter(moment());
			})
		},
		user() {
			return this.$store.getters.getUser;
		},
	},
}
</script>